import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";

import papirusConfig from "./services/configService";

/* Importar Bootstrap */
// import Bootstrap from 'bootstrap'
import "bootstrap/dist/css/bootstrap.min.css";

Vue.config.productionTip = false;
Vue.config.warnHandler = function (msg, vm, info) {
  /*your code*/
  console.log(info);
  console.log(msg);
  //vm.$forceUpdate();
};
Vue.config.errorHandler = function (error) {
  console.error(error);
  console.debug(error.message);
  if (error.message == "Maximum call stack size exceeded")
    window.location.reload();
  if (error.message == "too much recursion") window.location.reload();

  //cd..InternalError: too much recursion
};

(async () => {
  try {
    await papirusConfig.getConfiguration();

    if (papirusConfig.isConfigurationValid()) {
      await store.dispatch(
        "setApiBaseUrl",
        papirusConfig.currentConfig.APiEndPoint
      );
      await store.dispatch(
        "setAuthBaseUrl",
        papirusConfig.currentConfig.AuthEndpoint
      );

      Vue.prototype.$APiEndPoint = papirusConfig.currentConfig.APiEndPoint;
      Vue.prototype.$AuthEndpoint = papirusConfig.currentConfig.AuthEndpoint;

      await store.dispatch("setApplicationConfig", papirusConfig.currentConfig);

      await store.dispatch("loadPersistedState");
      /* OHG, Implementación de actualización de la vista sin refrescar
      https://stackoverflow.com/questions/57751233/vue-js-how-to-update-the-layout-without-refreshing
      */

      const updateSizes = (obj = {}) => {
        obj.width = window.innerWidth;
        obj.height = window.innerHeight;
        return obj;
      };

      Object.defineProperty(Vue.prototype, "$viewport", {
        value: Vue.observable(updateSizes())
      });

      window.addEventListener("resize", () => {
        updateSizes(Vue.prototype.$viewport);
      });

      new Vue({
        async created() {},
        router,
        store,
        render: (h) => h(App)
      }).$mount("#app");
    } else {
      document.write("Error de Configuración");
    }
  } catch (error) {
    document.write("Error de aplicación:" + error);
  }

  // the rest of the code
})();
